import React from 'react';

/**
 * TerminalPrompt - A terminal-style site title with blinking cursor
 * Displays "~ jasen.dev" with a blinking cursor animation
 */
const TerminalPrompt = ({ className = '' }) => {
  return (
    <div className={`ml-8 font-mono text-xl md:text-2xl ${className}`}>
      <span className="text-lime-400">~</span>
      <span className="text-lime-400 ml-2">jasen.dev</span>
      <span className="inline-block w-3 h-6 md:h-7 ml-1 bg-lime-400 align-middle animate-blink" />
    </div>
  );
};

export default TerminalPrompt;
